<app-navbar title="Lista">
	<!--
	<a routerLink="./add" class="btn btn-primary">
		<i class="fas fa-plus"></i> Dodaj
	</a>
-->
</app-navbar>

<div id="loader" *ngIf="loader"><span class="spinner-border spinner-grow-lg"></span></div>

<app-tourism-schedules-filters
	[userFilters]="'tourism-schedules'"
	(selected)="filtersSelected($event)"
></app-tourism-schedules-filters>

<app-dynamic-table
	[elements]="data"
	[tableRows]="tableRows"
	(filtersClicked)="filtersOpen()"
	module="tourism-transport-list"
></app-dynamic-table>
